import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import DataTable from "../../components/DataTable";
import Tabs from "../../components/Tabs";
import Alert from "../../components/Alert";
import { listLedgers, getTrialBalance, getLedgerStatement } from "../../api/accountApi";
import "../Attendance/Attendance.css";

const today = () => new Date().toISOString().slice(0, 10);
const firstOfMonth = () => today().slice(0, 8) + "01";

/** Direct port of digicampusbd's Trial Balance + Ledger Book reports. */
export default function AccountReportsPage() {
  const [tab, setTab] = useState("trial-balance");
  const [fromDate, setFromDate] = useState(firstOfMonth());
  const [toDate, setToDate] = useState(today());
  const [ledgers, setLedgers] = useState([]);
  const [ledgerId, setLedgerId] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    listLedgers().then((list) => {
      setLedgers(list);
      if (list.length > 0) setLedgerId(String(list[0].ledgerId));
    });
  }, []);

  const load = () => {
    setError("");
    setLoading(true);
    const request = tab === "trial-balance" ? getTrialBalance(fromDate, toDate) : getLedgerStatement(ledgerId, fromDate, toDate);
    request
      .then(setRows)
      .catch(() => setError("Failed to load report."))
      .finally(() => setLoading(false));
  };

  useEffect(load, [tab, fromDate, toDate, ledgerId]);

  const trialBalanceColumns = [
    { key: "ledgerName", label: "Ledger" },
    { key: "categoryName", label: "Category" },
    { key: "totalDebit", label: "Debit", render: (r) => r.totalDebit.toFixed(2) },
    { key: "totalCredit", label: "Credit", render: (r) => r.totalCredit.toFixed(2) },
  ];
  const ledgerStatementColumns = [
    { key: "trnDate", label: "Date" },
    { key: "voucherNo", label: "Voucher" },
    { key: "trnType", label: "Type" },
    { key: "voucherNote", label: "Note" },
    { key: "debitAmount", label: "Debit", render: (r) => r.debitAmount.toFixed(2) },
    { key: "creditAmount", label: "Credit", render: (r) => r.creditAmount.toFixed(2) },
    { key: "runningBalance", label: "Balance", render: (r) => r.runningBalance.toFixed(2) },
  ];

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Account Reports</h1>
      </div>
      <Tabs
        tabs={[
          { key: "trial-balance", label: "Trial Balance" },
          { key: "ledger-statement", label: "Ledger Statement" },
        ]}
        active={tab}
        onChange={setTab}
      />

      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>

      <div className="attendance-filters">
        {tab === "ledger-statement" && (
          <label>
            Ledger
            <select value={ledgerId} onChange={(e) => setLedgerId(e.target.value)}>
              {ledgers.map((l) => (
                <option key={l.ledgerId} value={l.ledgerId}>
                  {l.ledgerName}
                </option>
              ))}
            </select>
          </label>
        )}
        <label>
          From
          <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        </label>
        <label>
          To
          <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
        </label>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <DataTable columns={tab === "trial-balance" ? trialBalanceColumns : ledgerStatementColumns} rows={rows} />
      )}
    </MainLayout>
  );
}
